export default "__VITE_ASSET__a0U6hD9r__"